import React from 'react'
import "./../styles/article.css";

const Celebrities = () => {
    return (
        <div className="card">
            <div className="Home__container">
                <div className="article-border">
                    <div className="article-container">
                        <div className='mb-20' id='celeb-intro'>
                            <h1 id='celeb-h1' className='article-mainheading'>From Choir to Fame: How High School Choirs Shaped America's Greatest Talents</h1>
                            <img src='images/famous.png' />
                        </div>

                        <div className='paragraphwimage-left'>
                            <img src='images/celebs/1.jpg' />

                            <p>On January 20, 1976, George H.W. Bush was sworn
                                in as the 11th Director of the CIA. Shortly after,
                                during an interview with Morley Safer on 60 Minutes,
                                Safer asked him, “What do you know about being
                                the Director of an organization like the CIA?” Bush
                                replied, “I learned about  leadership from my choral
                                directors at Andover Academy and the Yale Glee
                                Club. First, there can be no wrong notes—just one can ruin the harmony
                                and turn music into chaos. Second, everyone must follow the conductor’s
                                timing and interpretation. As the new Director of the CIA, I will ensure we
                                work in unison and follow directives. Most of what I’ve learned about life
                                and leadership came from either a baseball field or a choral room. These
                                lessons have shaped my success and will bring a new direction to the
                                CIA.”</p>

                            <p>This raises a compelling question: how many successful lives are being
                                shaped in choral classrooms across America every day?</p>
                        </div>

                        {/* img on left */}
                        <div id='aaaaahhh'>
                            <h2 className='they-were mb-10'>They Were in Choir...</h2>
                        </div>


                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/2.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Amy Adams</h3>
                                <p>Golden Award-Winning Actress
                                    Douglas County High School
                                    Castle Rock, Colorado</p>
                            </div>
                        </div>

                        {/* img on right */}
                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Troy Aikman</h3>
                                <p>NFL Hall of Fame Player
                                    Henryetta High School
                                    Henryetta, Oklahoma
                                    BS in Sociology UCLA</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/3.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/4.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Clay Aiken</h3>
                                <p>Pop Singer
                                    Leesville Road High School
                                    Raleigh, North Carol</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Marcus Allen</h3>
                                <p>NFL Hall of Fame Football Player
                                    Abraham Lincoln High School
                                    San Diego, California
                                    Attended the USC</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/5.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/6.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Kelsea Ballerini</h3>
                                <p>Award-Winning County Music Singer
                                    Central High School,
                                    Knoxville, Tennessee</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Lance Bass</h3>
                                <p>Singer for Pop Boyband “NSYNC”
                                    Clinton High School
                                    Clinton, Mississippi</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/7.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/8.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Jeff Bridges</h3>
                                <p>Academy, Golden Globe, and Emmy
                                    Award-Winning Actor
                                    University High School,
                                    Los Angeles, California</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>J’Nai Bridges</h3>
                                <p>Grammy Award-Winning
                                    New York Metropolitan Opera Singer
                                    Charles Wright Academy:
                                    Tacoma, Washington
                                    Performance Curtis Institute of Music
                                    Philadelphia, Pennsylvania</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/9.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/10.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Kane Brown</h3>
                                <p>Country Music Singer and Songwriter
                                    Lakeview Fort Oglethorpe
                                    High School:
                                    Fort Oglethorpe, Georgia</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Sandra Bullock</h3>
                                <p>Academy Award-Winning Actress
                                    Washington-Lee High School
                                    Arlington, Virginia
                                    BFA from East Carolina University</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/11.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/12.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Carol Burnett</h3>
                                <p>Tony, Grammy, and Emmy
                                    Award-Winning Comedian, Singer,
                                    Actress, and Producer
                                    Hollywood High School
                                    Hollywood, California
                                    BA in Theater Arts from UCLA</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>George H.W. Bush</h3>
                                <p> 41st President of the United States
                                    Phillips Academy:
                                    Andover, Massachusetts
                                    President of Yale University
                                    Glee Club
                                    BA in Economics from
                                    Yale University</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/13.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/14.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Kristen Chenoweth</h3>
                                <p>Tony Award-Winning Performer
                                    Broken Arrow High School
                                    Broken Arrow, Oklahoma
                                    BA in Musical Theater,
                                    Oklahoma City University</p>
                            </div>
                        </div>


                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Kelly Clarkson</h3>
                                <p>Grammy Award-Winning Singer
                                    and TV Hostess
                                    Burleson High School
                                    Burleson, Texas</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/15.jpg' />
                            </div>
                        </div>


                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/16.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Luke Combs</h3>
                                <p>Award Winning Country
                                    Music Performer
                                    Reynolds High School
                                    Asheville, North Carolina
                                    Attended Appalachian
                                    State University</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Bradley Cooper</h3>
                                <p>Award-Winning Performer
                                    Germantown Academy
                                    Philadelphia, Pennsylvania
                                    Georgetown University Undergraduate
                                    MFA from The New School
                                    of New York</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/17.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/18.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Kevin Costner</h3>
                                <p>Academy Award-Winning Actor
                                    and Filmmaker
                                    Villa Park High School
                                    Villa Park, California</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Sheryl Crow</h3>
                                <p>Grammy Award-Winning Singer
                                    Kennett High School
                                    Kennett, Missouri
                                    BS in Music Education from the
                                    University of Missouri</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/19.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/20.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Lauren Daigle</h3>
                                <p>Grammy Award-Winning
                                    Christian Singer
                                    Westminster Christian Academy
                                    Lafayette, Louisiana
                                    Attended Louisiana State University</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Ellen DeGeneres</h3>
                                <p>Comedian and Emmy Award-Winner
                                    Atlanta High School
                                    Atlanta, Texas
                                    Attended University of New Orleans</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/21.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/22.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Zooey Deschanel</h3>
                                <p>Award-Winning Actress and Musician
                                    Crossroads School for Arts
                                    and Sciences
                                    Santa Monica, California
                                    Attended Northwestern University</p>
                            </div>
                        </div>


                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Snoop Dogg</h3>
                                <p>Award-Winning Rapper and Producer
                                    Long Beach Polytechnic High School
                                    Long Beach, California</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/23.jpg' />
                            </div>
                        </div>



                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/24.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Tina Fey</h3>
                                <p>Emmy Award-Winning Actress
                                    and Comedian
                                    Upper Darby High School
                                    Drexel, Pennsylvania
                                    BA in Drama from University
                                    of Virginia</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Jamie Foxx</h3>
                                <p>Academy Award-Winning
                                    Actor & Singer
                                    Terrell High School
                                    Terrell Texas</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/25.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/26.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Lady Gaga</h3>
                                <p>Grammy Award Winning Singer
                                    and Songwriter
                                    Convent of the Sacred Heart School
                                    New York, New York
                                    Attended NYU Tish School of the Arts</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Amy Grant</h3>
                                <p>Grammy Winning Christian Singer
                                    Kennedy Center Honoree
                                    Harpeth Hall School
                                    Nashville, Tennessee
                                    Attended Furman University</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/27.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/28.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Jonathan Groff</h3>
                                <p>Tony and Grammy Winning Performer
                                    Conestoga Valley High School
                                    Lancaster, Pennsylvania</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Anne Hathaway</h3>
                                <p>Academy Award-Winning Actress
                                    Milburn High School
                                    Milburn, New Jersey
                                    Attended Vassar College and NYU</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/29.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/30.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Heather Headley</h3>
                                <p>Tony and Grammy Winning Performer
                                    Northrop High School
                                    Fort Wayne, Indiana
                                    Attended Northwestern University</p>
                            </div>
                        </div>


                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Whitney Houston</h3>
                                <p>Grammy Award-Winning Singer
                                    Mount Saint Dominic Academy
                                    Caldwell, New Jersey</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/31.jpg' />
                            </div>
                        </div>



                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/32.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Jennifer Hudson</h3>
                                <p>Emmy, Grammy, Oscar, and Tony
                                    Award-Winning Performer
                                    Dunbar Vocational High School
                                    Chicago, Illinois
                                    Attended Langston University</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Nora Jones</h3>
                                <p>Grammy Award-Winning Singer
                                    Book T Washington High School
                                    For the Performing Arts
                                    Dallas, Texas
                                    Attended University of North Texas</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/33.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/34.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Quincy Jones</h3>
                                <p>Grammy Award-Winning Producer
                                    & Composer
                                    Garfield High School
                                    Seattle, Washington
                                    Attended Berklee School of Music</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Anna Kendrick</h3>
                                <p>Famous Film and Broadway Actress
                                    Deering High School
                                    Portland, Maine</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/35.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/36.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Alicia Keys</h3>
                                <p>Grammy Award-Winning Performer
                                    Professional Performing Arts School
                                    New York, New York</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Beyonce’ Knowles</h3>
                                <p> Grammy Award-Winning  Singer
                                    High School for the Performing Arts
                                    Houston, Texas</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/37.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/38.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Allison Krauss</h3>
                                <p>Grammy Award
                                    Champaign Central High School
                                    Champaign, Illinois</p>
                            </div>
                        </div>


                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Lenny Kravitz</h3>
                                <p>Grammy Award Winning Singer
                                    and Songwriter
                                    Beverly Hills High School</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/39.jpg' />
                            </div>
                        </div>


                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/40.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Aston Kutcher</h3>
                                <p>Television Actor and Venture Capitalist
                                    Clear Creek Amana High School
                                    Tiffin, Iowa
                                    Attended the University of Iowa</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Nick Lachey</h3>
                                <p>Lead-Singer of Boyband
                                    “98 Degrees”
                                    School for Creative &
                                    Performing Arts
                                    Cincinnati, Ohio</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/41.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/42.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Miranda Lambert</h3>
                                <p>Grammy Award-Winning Country Artist
                                    Lindale High School
                                    Dallas, Texas</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Queen Latifah</h3>
                                <p>Famous Rapper and Actress
                                    Irvington High School
                                    Newark, New Jersey</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/43.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/44.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Sugar Ray Leonard</h3>
                                <p>Champion Boxer
                                    Parkdale High School
                                    Riverpark, Maryland</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Blake Lively</h3>
                                <p>Actress and Film Director
                                    Burbank High School
                                    Burbank, California</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/45.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/46.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Audra McDonald</h3>
                                <p>Tony and Emmy Award-Winning
                                    Performer
                                    Theodore Roosevelt High School
                                    Fresno, California
                                    Attended The Juilliard School</p>
                            </div>
                        </div>


                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Bette Midler</h3>
                                <p>Tony, Grammy, Emmy
                                    Award-Winning Performer
                                    Radford High School
                                    Honolulu, Hawaii
                                    Attended the University of
                                    Hawaii at Mono</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/47.jpg' />
                            </div>
                        </div>






                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/48.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Lin-Manuel Miranda</h3>
                                <p>Pulitzer, Tony. Grammy, &
                                    Emmy Award-Winning
                                    Librettist, Actor, Singer, Rapper,
                                    & Songwriter
                                    Hunter College High School
                                    New York, New York
                                    Attended Wesleyan University in
                                    Musical Theater</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Matthew Morrison</h3>
                                <p>Broadway and Television Performer
                                    Las Alamitos High School and
                                    Orange County School of the Arts
                                    Las Alamitos, California
                                    Attended NYU Tisch School of the Arts</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/49.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/50.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Jason Mraz</h3>
                                <p>Grammy Award-Winning Singer
                                    & Songwriter
                                    Mechanicsville High School
                                    Mechanicsville, Virginia</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Barack Hussein Obama</h3>
                                <p>44th President of the United States
                                    Punahou School
                                    Honolulu, Hawaii
                                    Attended Occidental College, Columbia
                                    University and Harvard Law School</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/51.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/52.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Kelli O’Hara</h3>
                                <p>Tony Award-Winning and New York
                                    Metropolitan Opera Performer
                                    Deer Creek High School
                                    Elk City, Oklahoma
                                    Attended Oklahoma City University</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Danica Patrick</h3>
                                <p>Race Car Driver
                                    Hononegah Community High School
                                    Rockton, Illinois</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/53.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/54.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Andy Pettitte</h3>
                                <p>Retired Pitcher New York Yankees
                                    Deer Park High School
                                    Deer Park, Texas
                                    Attended San Jacinto College</p>
                            </div>
                        </div>


                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Brad Pitt</h3>
                                <p> Academy Award Winning Actor
                                    Kickapoo High School
                                    Springfield, Missouri</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/55.jpg' />
                            </div>
                        </div>




                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/56.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>John Roberts</h3>
                                <p>17th Chief Justice of the United States
                                    La Lumiere School
                                    LaPorte, Indiana
                                    Attended Harvard University and
                                    Harvard Law School</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Axl Rose</h3>
                                <p>Lead for Rock Band “Guns N’ Roses”
                                    Lafayette-Jefferson High School
                                    Lafayette, Indiana</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/57.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/58.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Kyle Schwarber</h3>
                                <p>Major League Baseball Player
                                    Parkdale High School
                                    Riverpark, Maryland
                                    Attended Indiana University</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Amanda Seyfried</h3>
                                <p>Famous Actress & Singer-Songwriter
                                    William Allen High School
                                    Allentown, Pennsylvania</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/59.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/60.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Brandon Sherrod</h3>
                                <p>Professional Basketball Player and
                                    Coach of the Yale Men’s
                                    Basketball Team
                                    Choate Rosemary Hall
                                    Wallingford, Connecticut
                                    Attended Yale University</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Meryl Streep</h3>
                                <p>Academy Award-Winning Actress
                                    Bernards High School
                                    Bernardsville, New Jersey
                                    Attended Vassar College and
                                    Yale University for MFA</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/61.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/62.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Barbra Streisand</h3>
                                <p>Academy, Emmy, Tony and Grammy
                                    Award-Winning Performer
                                    Erasmus Hall High School
                                    Brooklyn, NY</p>
                            </div>
                        </div>


                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Taylor Swift</h3>
                                <p>Grammy Award-Winning Performer
                                    Hendersonville High School
                                    Hendersonville, Tennessee</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/63.jpg' />
                            </div>
                        </div>




                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/64.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Raymond John Tester</h3>
                                <p>Former US Congressman and Senator
                                    Big Sandy High School
                                    Big Sandy, Montana
                                    Attended College of Great Falls
                                    as a Music Major</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Justin Tucker</h3>
                                <p>NFL Placekicker Baltimore Ravens
                                    West Lake High School
                                    Austin, Texas
                                    LaPorte, Indiana
                                    Attended the University of Texas as
                                    A Vocal Performance Major</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/65.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/66.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Josh Turner</h3>
                                <p>Country Music Singer and Songwriter
                                    Hannah-Pamplico High School
                                    Hannah, South Carolina
                                    Attended Belmont University</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Carrie Underwood</h3>
                                <p>Grammy Award-Winning
                                    Country Singer
                                    Checotah High School
                                    Checotah, Oklahoma
                                    Attended Northeastern
                                    State University</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/67.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/68.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Usher Raymond IV</h3>
                                <p>Grammy Award-Winning R&B and
                                    Pop Performer
                                    North Springs High School
                                    Sandy Springs, Georgia</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Roger Wicker</h3>
                                <p>US Senator from Mississippi
                                    Pontotoc High School
                                    Pontotoc, Mississippi
                                    Attended University of Mississippi and
                                    University of Mississippi Law School</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/69.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/70.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Vanessa Williams</h3>
                                <p>Broadway, TV, Movie Actress,
                                    Recording Artist and Miss America
                                    Horace Greeley High School:
                                    Chappaqua, New York
                                    Attended Syracuse University</p>
                            </div>
                        </div>


                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Patrick Wilson</h3>
                                <p>TV, Movie, and Broadway Actor
                                    Shorecrest Preparatory School
                                    St. Petersburg, Florida
                                    Attended Carnegie Mellon University</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/71.jpg' />
                            </div>
                        </div>




                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/72.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Reese Witherspoon</h3>
                                <p>Academy Award-Winning Actress
                                    and Producer
                                    Harpeth Hall School:
                                    Nashville, Tennessee
                                    Attended Stanford University</p>
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Trisha Yearwood</h3>
                                <p>Grammy Winning Country
                                    Music Singer
                                    Jasper County High School
                                    Monticello, Georgia
                                    Attended Young Harris College and
                                    Belmont University</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/73.jpg' />
                            </div>
                        </div>

                        <div className='celeb-card'>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/74.jpg' />
                            </div>
                            <div className='celeb-card-content'>
                                <h3>Chris Young</h3>
                                <p>County Music Singer and Songwriter
                                    Oakland High School
                                    Murfreesboro, Tennessee</p>
                            </div>
                        </div>


                        <div className='celeb-card'>
                            <div className='celeb-card-content'>
                                <h3>Renee Zellweger</h3>
                                <p>Academy Award-Winning Actress
                                    Katy High School
                                    Katy, Texas
                                    Attended the University of Texas</p>
                            </div>
                            <div className='celeb-card-img'>
                                <img src='images/celebs/75.jpg' />
                            </div>
                        </div>




                        <img src='images/celebs/outro.jpg' className='full-width-img' />

                        <p className='mt-10 mb-10'>Think we missed someone? If you’re certain they were in high school choir
                            or even better, show choir - we want to know! Share their name, their high
                            school, its location, and what makes the famous on our <a href='https://www.facebook.com/profile.php?id=61571698236116' target='_blank'>Facebook page</a>,
                            Between Choirs. Let’s shine a spotlight on their achievements together!</p>














                    </div>

                    <div className='article-ad'>
                        <a href='https://www.nationalscholasticmusiciansawards.com/' target='_blank'>
                            <img src='images/nsma.png' />
                        </a>
                    </div>
                    <div className='nsma-text'>
                        <a href='https://www.nationalscholasticmusiciansawards.com/' target='_blank'>
                            <h2>Check Out</h2>
                            <h3 className='nsmah3'>NationalScholasticMusiciansAwards.com</h3>

                            <h4 className='nsmah4'>NationalScholastic</h4>
                            <h4 className='nsmah4'>MusiciansAwards.com</h4>
                        </a>

                    </div>


                </div>
            </div>
        </div>
    )
}

export default Celebrities